export default "__VITE_ASSET__f8SRZojT__"